var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FULFILLMENT_TYPE } from '../../constants/status';
import { SubmitAddAddress, SubmitDeliveryAddressCreateCart, SubmitValidateDeliveryAddress, } from '../../api/oms/edit-delivery-address';
import { FLOW_TYPES } from '../../constants/out-of-stock';
import { OmmEditDeliveryAddressAppify } from '../../hooks/delivery-hooks';
import { TrackErrorEventEditDeliveryAddressAnalytics } from './analytics';
import { isBopisOutOfStockRecoverable } from '../../components/order-details/util/FulfillmentStatus';
import { FeatureSwitches } from '../../constants/feature-switches';
import { convertedFulfillmentTypes } from '../../components/order-details/OrderTrackingDetails';
/**
 * @param lineItems LineItems array from fulfillmentGroup (OrderDetailsResponse).
 * @returns Array of lineIds or empty array.
 */
export var mapLineIds = function (lineItems) {
    return ((lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter(function (lineItem) {
        return !(lineItem === null || lineItem === void 0 ? void 0 : lineItem.parentLine) && !(lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineParentId);
    }).map(function (lineItem) { var _a; return (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineId) !== null && _a !== void 0 ? _a : ''; })) || []);
};
export var submitEditDeliveryAddress = function (_a) {
    var _b;
    var deliveryAddress = _a.deliveryAddress, firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, isDefaultValue = _a.isDefaultValue, orderDetailsData = _a.orderDetailsData, fulfillmentTypeCode = _a.fulfillmentTypeCode, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, isAddingNewAddress = _a.isAddingNewAddress, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, fulfillmentGroup = _a.fulfillmentGroup, traceId = _a.traceId, setIsChangeForm = _a.setIsChangeForm, setIsDeliveryDetails = _a.setIsDeliveryDetails, setIsLoading = _a.setIsLoading, setShowDrawerError = _a.setShowDrawerError, setExcludedShipStateApiError = _a.setExcludedShipStateApiError, setIsExcludedAddress = _a.setIsExcludedAddress, setIsValidated = _a.setIsValidated, closeDrawer = _a.closeDrawer, setUpdatedAddressData = _a.setUpdatedAddressData, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, flowType = _a.flowType, setIsDeliveryOptions = _a.setIsDeliveryOptions;
    var addAddressRequestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        flowType: flowType,
        address: __assign(__assign({}, deliveryAddress), { firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue, isDefault: isDefaultValue }),
        fulfillmentType: fulfillmentTypeCode,
        originalFulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || undefined,
        newFulfillmentType: null,
    };
    var createCart = function () {
        SubmitDeliveryAddressCreateCart({
            requestData: deliveryAddressCreateCartRequestData,
            setIsChangeForm: setIsChangeForm,
            setIsDeliveryDetails: setIsDeliveryDetails,
            setIsLoading: setIsLoading,
            setShowDrawerError: setShowDrawerError,
            setExcludedShipStateApiError: setExcludedShipStateApiError,
            setIsExcludedAddress: setIsExcludedAddress,
            setIsValidated: setIsValidated,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            fulfillmentGroup: fulfillmentGroup,
            closeDrawer: closeDrawer,
            setUpdatedAddressData: setUpdatedAddressData,
            setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
            traceId: traceId,
            setIsDeliveryOptions: setIsDeliveryOptions,
        });
    };
    if (isAddingNewAddress) {
        // SubmitAddAddress is fire-and-forget (regardless of success or error we currently continue with no feedback to customer)
        SubmitAddAddress(addAddressRequestData, traceId);
    }
    createCart();
};
export var getAddresses = function (_a) {
    var _b;
    var orderDetailsData = _a.orderDetailsData, fulfillmentTypeCode = _a.fulfillmentTypeCode, isAuthTHDUser = _a.isAuthTHDUser, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, setDeliveryAddresses = _a.setDeliveryAddresses, setDeliveryAddressesApiError = _a.setDeliveryAddressesApiError, closeDrawer = _a.closeDrawer;
    var isBopisOutOfStock = isBopisOutOfStockRecoverable(fulfillmentGroup);
    var editDeliveryRequest = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        flowType: isBopisOutOfStock
            ? FLOW_TYPES.BOPIS_OOS_RECOVERY
            : FLOW_TYPES.EDIT_DELIVERY_ADDRESS,
        fulfillmentType: fulfillmentTypeCode,
        originalFulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || undefined,
        newFulfillmentType: null,
    };
    return OmmEditDeliveryAddressAppify(editDeliveryRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
        .then(function (response) {
        var _a, _b;
        setDeliveryAddresses(((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.addresses) || []);
        setDeliveryAddressesApiError(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
        });
    })
        .catch(function () {
        setDeliveryAddressesApiError(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
        });
        closeDrawer();
    });
};
export var goBackToChangeForm = function (suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails) {
    setSubmitCreateForm(false);
    setIsChangeForm(true);
    if (setIsConfirmation)
        setIsConfirmation(false);
    if (setIsDeliveryDetails)
        setIsDeliveryDetails(false);
    suspendCartCheck();
};
export var goBackToDeliveryDetails = function (suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails) {
    setIsChangeForm(false);
    if (setIsConfirmation)
        setIsConfirmation(false);
    if (setIsDeliveryDetails)
        setIsDeliveryDetails(true);
    suspendCartCheck();
};
export var goBackToDeliveryOptions = function (suspendCartCheck, setIsDeliveryOptions, setIsDeliveryDetails) {
    setIsDeliveryOptions(true);
    setIsDeliveryDetails(false);
    suspendCartCheck();
};
export var validateDeliveryAddress = function (_a) {
    var _b;
    var firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, streetAddressValue = _a.streetAddressValue, addressLineTwoValue = _a.addressLineTwoValue, zipCodeValue = _a.zipCodeValue, cityStateValue = _a.cityStateValue, country = _a.country, flowType = _a.flowType, fulfillmentTypeCode = _a.fulfillmentTypeCode, orderDetailsData = _a.orderDetailsData, setInvalidField = _a.setInvalidField, setIsSameAddress = _a.setIsSameAddress, setIsLoading = _a.setIsLoading, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails, setShowDrawerError = _a.setShowDrawerError, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, setIsValidated = _a.setIsValidated, closeDrawer = _a.closeDrawer, setValidationEt = _a.setValidationEt, validationEt = _a.validationEt, traceId = _a.traceId, deliveryAddress = _a.deliveryAddress, checkSameAddress = _a.checkSameAddress, isPOBoxAddressLine1 = _a.isPOBoxAddressLine1, isPOBoxAddressLine2 = _a.isPOBoxAddressLine2, setSubmitCreateForm = _a.setSubmitCreateForm, EditDeliveryAddressErrorMessages = _a.EditDeliveryAddressErrorMessages, isValidated = _a.isValidated, isAddressList = _a.isAddressList;
    if (firstNameValue === '' ||
        lastNameValue === '' ||
        phoneNumberValue.length !== 12 ||
        streetAddressValue === '' ||
        zipCodeValue.length !== 5) {
        setInvalidField(true);
        TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', 'n/a', 'Invalid fields', 'advisory');
        return;
    }
    if (checkSameAddress()) {
        setIsSameAddress(true);
        TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', 'n/a', EditDeliveryAddressErrorMessages.SAME_ADDRESS, 'advisory');
        return;
    }
    if (isPOBoxAddressLine1 || isPOBoxAddressLine2) {
        return;
    }
    setIsLoading(true);
    setNewDeliveryAddressDetails(__assign(__assign({}, deliveryAddress), { firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue }));
    var requestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        address: {
            addressLine1: streetAddressValue,
            addressLine2: addressLineTwoValue,
            city: cityStateValue.split(',')[0],
            state: (_b = cityStateValue.split(',')[1]) === null || _b === void 0 ? void 0 : _b.trim(),
            zipCode: zipCodeValue,
            country: country,
        },
        flowType: flowType,
        fulfillmentType: fulfillmentTypeCode,
        originalFulfillmentType: fulfillmentTypeCode,
        newFulfillmentType: null,
    };
    SubmitValidateDeliveryAddress(requestData, isValidated, setSubmitCreateForm, setShowDrawerError, fulfillmentGroupIndex, setIsValidated, closeDrawer, setIsLoading, setValidationEt, validationEt, isAddressList, traceId);
};
export function getInitialZipCode(fulfillmentGroup, fulfillmentType) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    switch (fulfillmentType) {
        case FULFILLMENT_TYPE.STH: {
            return ((_d = (_c = (_b = (_a = fulfillmentGroup.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.deliveryAddress) === null || _b === void 0 ? void 0 : _b.postalDetails) === null || _c === void 0 ? void 0 : _c.zipCode) !== null && _d !== void 0 ? _d : '');
        }
        case FULFILLMENT_TYPE.BODFS: {
            return ((_k = (_j = (_h = (_g = (_f = (_e = fulfillmentGroup.bodfsDeliveryAndHandling) === null || _e === void 0 ? void 0 : _e.bodfsDeliveries) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.deliveryAddress) === null || _h === void 0 ? void 0 : _h.postalDetails) === null || _j === void 0 ? void 0 : _j.zipCode) !== null && _k !== void 0 ? _k : '');
        }
        case FULFILLMENT_TYPE.BOPIS: {
            return (_p = (_o = (_m = (_l = fulfillmentGroup.storePickup) === null || _l === void 0 ? void 0 : _l.store) === null || _m === void 0 ? void 0 : _m.address) === null || _o === void 0 ? void 0 : _o.zipCode) !== null && _p !== void 0 ? _p : '';
        }
        default:
            return '';
    }
}
export var getIsZipCodeEligibilityEnabled = function (fulfillmentGroup) {
    var isBopisOutOfStock = isBopisOutOfStockRecoverable(fulfillmentGroup);
    var isBopisOutOfStockFfaLiteCall = Boolean(FeatureSwitches.enableBopisOutOfStockFfaLiteCall);
    var isSFBLEnabled = Boolean(FeatureSwitches.isSFBLEnabled);
    return ((isSFBLEnabled && !isBopisOutOfStock) ||
        (isBopisOutOfStockFfaLiteCall && isBopisOutOfStock));
};
export var handleEligibility = function (response, availableFulfillmentOptions, fulfillmentGroup, updateFormField, setIsEligible) {
    var data = response.data;
    var isBopisOutOfStock = Boolean(isBopisOutOfStockRecoverable(fulfillmentGroup));
    if (isBopisOutOfStock) {
        // STH eligibility
        var isSTHEligible = data.availableFulfillmentOptions.delivery.fulfillmentOptions.STH
            .isEligible === true;
        if (isSTHEligible) {
            updateFormField({
                zipCodeValue: availableFulfillmentOptions.fulfillmentAddress.zipCode,
            });
        }
        setIsEligible(isSTHEligible);
    }
    else {
        // Delivery eligibility
        var isDeliveryEligible = data.availableFulfillmentOptions.delivery.isEligible === true;
        if (isDeliveryEligible) {
            updateFormField({
                zipCodeValue: availableFulfillmentOptions.fulfillmentAddress.zipCode,
            });
        }
        setIsEligible(isDeliveryEligible);
    }
};
